<div class="container-tab-lists">
  <mat-tab-group orientation="vertical" [mat-stretch-tabs]="false" #tabGroup (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel)">
    <mat-tab label="Protocols">
      <div class="inner-tcontainer-tab">
        <div class="panel-body osh-admin-panel">
          <p class="description">Manage OSH (Occupational Safety and Health) protocols</p>
          @if (defaults.isMersyAdminSafetySystemExcellence) {
            <div class="OrangeButton action-buttons">
              <button mat-raised-button (click)="onClickTranslDownload()" title="Download OSH Protocol Factors Translations" class="btn btn-sm button-color-fix">
                <mat-icon class="add-button icon-color-fix">download</mat-icon>Download Translations
              </button>
              <button mat-raised-button (click)="onClickTranslUpload()" title="Upload OSH Protocol Factors Translations" class="btn btn-sm button-color-fix">
                <mat-icon class="add-button icon-color-fix">upload</mat-icon>Upload Translations
              </button>
              <button mat-raised-button (click)="onClickDownloadProtocols()" title="Download Protocol Factors Template" class="btn btn-sm button-color-fix">
                <mat-icon class="add-button icon-color-fix">download</mat-icon>Download Factors
              </button>
              <button mat-raised-button (click)="onClickUploadProtocols()" title="Upload Protocol Factors Excel" class="btn btn-sm button-color-fix">
                <mat-icon class="add-button icon-color-fix">upload</mat-icon>Upload Factors
              </button>
            </div>
          }
        </div>

        <!-- Protocol Tables - One for each protocol -->
        @if (protocols && protocols.length > 0) {
          <div class="protocol-tables-section">
            @for (protocol of protocols; track protocol) {
              <app-protocol-factor-table
                [protocol]="protocol">
              </app-protocol-factor-table>
            }
          </div>
        }

        <!-- No Protocols Message -->
        @if (!protocols || protocols.length === 0) {
          <div class="no-protocols-message">
            <mat-icon>info</mat-icon>
            <p>No protocols found. Please contact your administrator to set up OSH protocols.</p>
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Waves">
      <div class="inner-tcontainer-tab">
        <div class="panel-body row">
          <p>In order to configure a specific wave (configuring protocols or assigning branches), please select a wave clicking on respective arrow.</p>
        </div>

        <div class="waves-section">
          <osh-wave (selectedWaveEmit)="onSelectedWave($event)"></osh-wave>
          @if (selectedWave.id !== -1) {
            <osh-waveprotocolconfig [selectedWave]="selectedWave"></osh-waveprotocolconfig>
          }
          @if (selectedWave.id !== -1) {
            <osh-wavebranchconfig [selectedWave]="selectedWave"></osh-wavebranchconfig>
          }
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>